import axios from "axios";
import { endpoint } from "../../config";
import { customToast } from "../../lib/toastLib";

export const partnerIdByUrlSegment = async (urlSegment) => {
  try {
    const apiLink = `${endpoint}/api/get-partner-id-by-url-segment/${urlSegment}`;
    const response = await axios.get(apiLink);
    const data = response.data;

    if (data?.success) {
      return data?.partner_id;
    } else throw new Error("Partner not found");
  } catch (error) {
    return null;
  }
};
